<template>
    <div class="bg">
        <div class="con m_rl_20">
            <div>
                <img src="../assets/img/cnt_top_logo.png" alt="" class="logo">
                <img v-if="$i18n.locale == 'en'" src="../assets/img/jindutiao2.png" alt="" class="jindu">
                <img class="jindu" v-else src="../assets/img/jindutiao2_cn.png" alt="">
            </div>
            <div class="cont ">
                <img src="../assets/img/back.png" alt="" class="back" @click="back">
            </div>
            <div class="descript ">
                <div class="descript_title">{{ $t('OrderDetails') }}</div>
                <ul>
                    <li>
                        <div>{{ $t('NFTName') }}</div>
                        <div class="span">{{ $t('CarbonNeutralFor') }} {{ certificateDetail.operationName }}</div>
                    </li>
                    <li>
                        <div>{{ $t('NFTAmount') }}</div>
                        <div class="span">US$ {{ formatStr(price, 2) }}</div>
                    </li>
                    <!-- <li>
                        <div>Gas Fee</div>
                        <div class="span">MVGX</div>
                    </li> -->
                </ul>
            </div>
            <div class="descript ">
                <div class="descript_title">{{ $t('NameorNickname') }}</div>
                <div class="input_wrap">
                    <el-input type="textarea" :rows="3" resize='none'
                        :placeholder="$t('Addyournameornickname')" v-model="nickName">
                    </el-input>
                </div>
            </div>
            <div class="descript ">
                <div class="descript_title">{{ $t('PersonalizedMessage') }}</div>
                <div class="input_wrap input_wrap1">
                    <el-input type="textarea" :rows="5" resize='none'
                        :placeholder="$t('Typeinyourpersonalisedtextsdisplaye')"
                        v-model="textarea" @input="inputTextarea">
                    </el-input>
                    <div class="nums">{{ numberNums }}/{{ nums }}</div>
                </div>
            </div>
            <div class="tips">
                <el-checkbox v-model="check"></el-checkbox>
                <span>
                    {{ $t('Iwouldliketodisplay') }}
                </span>

            </div>



            <!-- <div class="button_wrap m_rl_20">
                <div class="price">
                    <div>US$
                    <span>39.70</span></div>
                    <div class="total">Total</div>
                    
                </div>
                <el-button class="bths"
                    >Confirm</el-button
                >
            </div> -->
            <div class=" btn_wrap" style="padding-bottom:1.25rem">
                <el-button class="btn" @click="dialogVisible = true">{{ $t('Preview') }}</el-button>
                <el-button class="btn btn_world" @click="generate" v-if="status == 1" :disabled="btnDisabled">{{ $t('GenerateYourNFT') }}</el-button>
                <!--   -->
                <!-- <div  id="paypal-button-container"></div> -->
            </div>
        </div>


        <el-dialog :visible.sync="dialogVisible" width="90%" :before-close="handleClose">
            <div class="img_wrap">
                <img src="../assets/img/wei1.png" alt=""
                    v-if="certificateDetail.operationName == 'Digital Life Design 2022'">
                <img src="../assets/img/wei2.png" alt="" v-else>
                <span class="span">
                    <div style="font-weight:bold;margin-bottom:.3125rem">{{ nickName ? nickName : '' }}</div>
                    <span style="font-size:.75rem">
                        {{ textarea ? textarea : '' }}
                    </span>
                </span>

            </div>
        </el-dialog>
    </div>
</template>

<script>
// import { loadScript } from '@paypal/paypal-js';
import cnt from '@/api/cnt.js'
import { formatStr } from '@/util/number.js'
export default {

    data() {
        return {
            sn: '',
            price: "",
            certificateDetail: {},
            // paid: false,
            textarea: '',
            check: false,
            nums: 64,
            numberNums: 0,
            sessionid: '',
            status: '',
            btnDisabled: false,
            nickName: '',
            dialogVisible: false,
            config: '',
        }
    },
    // beforeCreate(){
    // this._wsc = document.createElement('script');
    // this._wsc.src = "https://www.paypal.com/sdk/js?client-id=AXh_ZxZc865MtLK6ozAxrQOUX1Qkat768CBj4sAC3XbsWc2wZcJM3EPbdPnW5zCZHwM8H21Af74OOBXA&currency=USD";
    // document.getElementsByTagName('Head')[0].appendChild(this._wsc);
    // },

    // beforeCreate: function() {
    //     loadScript({ 'client-id': CLIENT_ID }).then((paypal) => {
    //     paypal
    //         .Buttons({
    //             createOrder: this.createOrder,
    //             onApprove: this.onApprove,
    //         })
    //         .render('#paypal-button-container');
    //     });
    // },
    created() {
        this.sn = this.$route.query.sn;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
    },
    mounted() {
        // this.sn = this.$route.query.sn
        // this.price = this.$route.query.price
        this.sn = localStorage.getItem('sn')
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
        this.qsn = this.$route.query.sn

        this.price = localStorage.getItem('price')
        this.sessionid = this.$route.query.sessionid
        if (this.qsn) {
            this.sn = this.qsn
            this.getTravelRecord()
        } else if (this.sessionid) {
            this.getOrder()
            this.getTravelRecord()
        }

    },
    methods: {
        handleClose() {
            this.dialogVisible = false
        },
        formatStr: formatStr,
        back() {
            this.$router.go(-1)
        },
        getOrder() {
            cnt.getOrder(res => {
                this.status = res.status
                if (res.status == -1) {
                    this.$message.error(this.$t('InvalidOrderID'))
                    setTimeout(function () {
                        this.$router.push({ path: "/detail", query: { sn: this.sn } });
                    }, 1000)
                }

            }, { orderId: this.sessionid })
        },
        getTravelRecord() {
            cnt.getTravelRecord(
                (res) => {
                    // 打开
                    if (this.qsn) {
                        if (res.captureStatus == -1 || !res.captureStatus) {
                            this.$router.push({ path: "/detail", query: { sn: this.sn } });
                        } else if (res.captureStatus == 2) {
                            this.$router.push({ path: "/success", query: { sn: this.sn } });
                        } else {
                            this.status = 1
                        }
                    }
                    this.certificateDetail = res;
                    this.nickName = res.name
                },

                { sn: this.sn }
            );
        },

        // createOrder: function(data, actions) {
        //     console.log('Creating order...');
        //     return actions.order.create({
        //         purchase_units: [
        //             {
        //                 amount: {
        //                     value: this.price,
        //                 },
        //             },
        //         ],
        //     });
        // },
        // onApprove: function(data, actions) {
        //     return actions.order.capture().then((res) => {
        //         // this.paid = true;
        //         console.log('Order complete!',res);

        //         let data = {
        //             sn:this.sn,
        //             orderId:res.id,
        //             description:this.textarea,
        //             privacy:this.check
        //         }
        //         cnt.getNftStatus(res => {
        //             if(res.status == 1){
        //                 this.$router.push({ path: "/success", query: { sn: this.sn } });
        //             }else{
        //                 this.$message.error('payment failure')
        //             }
        //         },data)
        //     });
        // },

        generate() {
            this.btnDisabled = true;
            if (!this.nickName) {
                this.$message.error(this.$t('Nameisrequired'))
                return
            }
            let data = {
                sn: this.sn,
                orderId: this.sessionid,
                description: this.textarea,
                privacy: this.check,
                nickName: this.nickName
            }
            cnt.getNftStatus(res => {
                this.btnDisabled = false;
                if (res.status == 2) {
                    this.$router.push({ path: "/success", query: { sn: this.sn } });
                } else {
                    this.$message.error(this.$t('FailedtogenerateyourNFT'))
                }
            }, data)
        },
        inputTextarea(e) {
            if (e.length < this.nums) {
                this.numberNums = e.length
                this.textarea = e
            } else {
                this.numberNums = this.nums
                this.textarea = e.slice(0, this.nums)

            }
            if (e.length == this.nums) {
                // cnt.calDescription(res => {
                //     console.log(res)
                //     // if(res)
                // },{description:e})
                this.$message.error(this.$t('Maximum64Characters'))
            }
        }

    }
}

const CLIENT_ID = 'Addbvt4U0CnOERlyRSq6Z-5OVlDGy3YRkDVmzvNmKlyqF552gL65xckz-UGYtKu_DLZSfAlf_j9oVhWw';
</script>
<style lang="less" scoped>
::v-deep .el-dialog__headerbtn .el-dialog__close {
    font-size: 1.625rem;
}

::v-deep .el-dialog {
    // background-color: transparent;
    box-shadow: none;
    border-radius: .625rem;
}

::v-deep .el-dialog__body {
    padding-top: 0;
}

.bg {
    width: 100%;
    min-height: 100%;
    background: url('../assets/img/bj.png') no-repeat;
    background-size: 100% 100%;
}

.con {
    padding-top: 9rem;
    // position: absolute;
    // top: 1.25rem;
    // left: 50%;
    // transform: translate(-50%,0);
}

.cont {
    .back {
        width: .8125rem;
        height: 1.375rem;
    }

}

.logo {
    width: 11.4063rem;
    height: 2.1875rem;
    position: absolute;
    top: 1.5rem;
    left: 1.25rem;
}

.jindu {
    width: 20.8438rem;
    height: 2.5938rem;
    position: absolute;
    top: 4.9375rem;
    // left: 1.2813rem;
    left: auto;
    right: auto;
}

.descript {
    margin-top: 1.875rem;
    margin-bottom: 1.25rem;

    .descript_title {
        color: #ffffff;
        // color: #1E1E1E;
        font-weight: bold;
        font-size: 1.25rem;
        font-family: Arial-BoldMT, Arial;
        margin-bottom: 1.25rem;
    }

    .input_wrap {
        padding: 1.25rem 1.25rem 23px;
        background: #FFFFFF;
        box-shadow: 0px .0625rem .75rem 0px rgba(15, 95, 75, 0.08);
        border-radius: 1.25rem;

    }

    ul {
        padding: 0 1.25rem 23px;
        background: #FFFFFF;
        box-shadow: 0px .0625rem .75rem 0px rgba(15, 95, 75, 0.08);
        border-radius: 1.25rem;

        li {
            list-style: none;
            padding: 1.125rem 0;
            border-bottom: .0625rem solid #E6F0F2;
            font-size: .9375rem;
            color: #8F8F8F;
            font-family: Century Gothic;

            .span {
                color: #303236;
                margin-top: .625rem;
            }

        }


    }


}

.tips {
    font-family: Century Gothic;
    color: #FFFFFF;
    line-height: 1rem;
    font-size: .75rem;
    margin: 0 1.25rem 2.1875rem;
    display: flex;

    span {
        margin-left: .75rem;
    }
}

.button_wrap {
    margin: 2.375rem 1.25rem 1.875rem;
    height: 3.0625rem;
    background: #FFFFFF;
    box-shadow: 0px .0625rem .75rem 0px rgba(15, 95, 75, 0.08);
    border-radius: .625rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .price {
        font-size: .75rem;
        font-family: Gotham-Book, Gotham;
        font-weight: normal;
        color: #1E1E1E;
        margin-left: 1.4375rem;

        span {
            font-size: 1.25rem;
            font-family: Gotham-Bold, Gotham;
            font-weight: bold;
            color: #1E1E1E;
        }

        .total {
            color: #C1C1C1;
            font-size: .75rem;
        }
    }

}

::v-deep .el-button {
    padding: 0;
}

::v-deep .el-textarea__inner {
    font-size: .75rem;
    border: .0625rem solid #E6F0F2;
    font-family: Century Gothic;
}

::v-deep .input_wrap1 .el-textarea__inner {
    height: 10.0625rem;
}



::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #68b4c6;
    border-color: #68b4c6;
}

.nums {
    text-align: right;
    font-size: .75rem;
    font-family: Century Gothic;
    color: #C1C1C1;
    margin-top: .5rem;
}

.btn_wrap {
    display: flex;
    justify-content: space-between;
}

.btn {
    width: 10.0625rem;
    height: 2.8125rem;
    color: #4d94a0;
    margin-bottom: 1.3125rem;
    border-radius: 0.625rem;
    font-size: 0.9375rem;
    font-family: Century Gothic;
    box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
    padding: 0;
}

.el-button+.el-button {
    margin: 0;
}

.btn_world {
    background-color: rgba(255, 255, 255, 0.13);
    backdrop-filter: blur(0.3125rem);
    border: 0.0625rem solid #ffffff;
    color: #fff;
}

.img_wrap {
    display: flex;
    justify-content: center;
    position: relative;
    margin-top: 1.25rem;

    img {
        width: 20rem;
        height: 20rem;
    }

    .span {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: .625rem;
        // font-size: .1875rem;
        width: 33%;
        text-align: center;
        white-space: normal;
        word-break: break-word;
    }

    .more1 {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: .1875rem;
        width: 33%;
        text-align: center;
        word-wrap: break-word;

    }
}
</style>